export const TableData = [
    {
        name: 'Nyarko Patience',
        class: 'Jss1',
        dateSubmitted: '06/02/2021',
        score: 10,
        dateScored: '08/02/2021',
        grade: 'B'
    },
    {
        name: 'Amaka Ikechukwu',
        class: 'Jss1',
        dateSubmitted: '06/02/2021',
        score: 10,
        dateScored: '08/02/2021',
        grade: 'A'
    },
    {
        name: 'Raymond Mfon',
        class: 'Jss1',
        dateSubmitted: '06/02/2021',
        score: 3,
        dateScored: '08/02/2021',
        grade: 'F'
    },
    {
        name: 'Olarenwaju',
        class: 'Jss1',
        dateSubmitted: '06/02/2021',
        score: 1,
        dateScored: '08/02/2021',
        grade: 'F'
    },
    {
        name: 'Bidemi Ajala',
        class: 'Jss1',
        dateSubmitted: '06/02/2021',
        score: 3,
        dateScored: '08/02/2021',
        grade: 'F'
    },
]
export const SchoolData = [
    {
        name: 'Temple College',
        motto: 'A citadel of excellence',
        highestLevel: 'SS3',
        schoolCode: 'TFC',
    },
    {
        name: 'Topflight College',
        motto: 'Secondary School',
        highestLevel: 'SS3',
        schoolCode: 'TFC',
    },
    {
        name: 'ChildNest',
        motto: 'Education with Excellence',
        highestLevel: 'SS3',
        schoolCode: 'TFC',
    },
    {
        name: 'Air Force Sec School',
        motto: 'Trust with Excellence',
        highestLevel: 'SS3',
        schoolCode: 'TFC',
    },
    {
        name: 'Salamah High School',
        motto: 'Grooming Next Billon Users',
        highestLevel: 'SS3',
        schoolCode: 'TFC',
    },
]
export const InstructorData = [
    {
        name: 'Ade	Bello',
        emailAddress: 'A citadel of excellence',
        phoneNumber: 'SS3',
        school: 'TFC',
    },
    {
        name: 'Topflight College',
        emailAddress: 'Secondary School',
        phoneNumber: 'SS3',
        school: 'TFC',
    },
    {
        name: 'ChildNest',
        emailAddress: 'Education with Excellence',
        phoneNumber: 'SS3',
        school: 'TFC',
    },
    {
        name: 'Air Force Sec School',
        emailAddress: 'Trust with Excellence',
        phoneNumber: 'SS3',
        school: 'TFC',
    },
    {
        name: 'Salamah High School',
        emailAddress: 'Grooming Next Billon Users',
        phoneNumber: 'SS3',
        school: 'TFC',
    },
]

export const AdminSystemSettingsData = [
    {
        session: '2017/2018',
        term: '1st term',
        schoolName: 'Klasconnect Portal',
        startDate: '2018-10-29',
        endDate: 'Not recorded',
    },
    {
        session: '2017/2018',
        term: '1st term',
        schoolName: 'Klasconnect Portal',
        startDate: '2018-10-29',
        endDate: 'Not recorded',
    },
    {
        session: '2017/2018',
        term: '3rd term',
        schoolName: 'Klasconnect Portal',
        startDate: '2018-10-29',
        endDate: '2019-05-13',
    },
    {
        session: '2018/2019',
        term: '2nd term',
        schoolName: 'Klasconnect Portal',
        startDate: '2018-10-29',
        endDate: '2020-04-18',
    },
    {
        session: '2018/2019',
        term: '2nd term',
        schoolName: 'Klasconnect Portal',
        startDate: '2018-10-29',
        endDate: 'Still on',
    },
]